import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}air_24/`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchStationsTwentyFour = createAsyncThunk(
  "stations/fetchStationsTwentyFour",
  async () => {
    const response = await axios.get(webApiUrl, {
      headers: { Authorization: `Token ${tokenStr}` },
    });
    return response.data;
  }
);

const stationsTwentyFourSlice = createSlice({
  name: "stationsTwentyFour",
  initialState: {
    stationsLoading: true,
    stationsData: {
      SAPA: [],
      ESPS: [],
      OSPM: [],
      SATA: [],
    },
    stationsError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStationsTwentyFour.pending, (state) => {
        state.stationsLoading = true;
      })
      .addCase(fetchStationsTwentyFour.fulfilled, (state, action) => {
        state.stationsLoading = false;
        state.stationsData = action.payload;
        state.stationsError = "";
      })
      .addCase(fetchStationsTwentyFour.rejected, (state, action) => {
        state.stationsLoading = false;
        state.stationsData = {
          SAPA: [],
          ESPS: [],
          OSPM: [],
          SATA: [],
        };
        state.stationsError = action.error.message;
      });
  },
});

export default stationsTwentyFourSlice.reducer;
